setAppLastInteractedTimestamp